import gql from 'graphql-tag'

export default gql`
    query getSegments($AdminUserID: String) {
        getSegments(AdminUserID: $AdminUserID) {
            ID
            Type
            DevStatus
            Description
            Audience {
                PartnerID
                LastCalc
                Audience{
                    UserID
                    UserEmail
                    DateJoined
                }
            }
            PriorAudience {
                PartnerID
                LastCalc
                Audience {
                    UserID
                    UserEmail
                    DateJoined
                    DateLeft
                }
            }
            LastUpdated
            Name
        }
    }
`
